import {BankOption} from "@/store/shop/types";
import {Player, UserSource} from "@/store/player/types";
import {SuperPackPanel} from "@/scenes.ui/super-pack-panel";
import {ChainItemType} from "@/model/chain-item-type";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {Tr} from "@/i18n/i18n";
import Image = Phaser.GameObjects.Image;
import Sprite = Phaser.GameObjects.Sprite;
import Text = Phaser.GameObjects.Text;

export class ChainPackPanel extends SuperPackPanel {

    private darkness: Image | undefined;
    private lock: Sprite | undefined;
    private chainItemType!: ChainItemType;

    constructor(scene: Phaser.Scene, x: number, y: number, bo: BankOption, player: Player, userSource: UserSource,
                buyCallback: () => void, heroDescCallback: (heroId: string) => void, chainItemType: ChainItemType, currIndex: number, isReward: boolean = false,
                productPriceView: string | undefined = undefined) {
        super(scene, x, y, bo, player, userSource, () => {
            if (this.chainItemType === ChainItemType.FUTURE) {
                new FeedbackPanel(scene, Tr('pr.pck'), undefined, false).show();
            } else {
                buyCallback();
            }
        }, heroDescCallback, isReward, productPriceView);
        this.chainItemType = chainItemType;

        this.initialize(bo);

        if (chainItemType === ChainItemType.FUTURE && this.buyButtonVisible(bo)) {
            this.lock = SpriteUtils.addSprite(this.scene, 500, this.getBuyButtonPos(bo.decorationId) - 35, Keys.ATLAS_CHAIN, 'block')
                .setOrigin(0.5, 0.5);
            this.add(this.lock);
        }

        switch (chainItemType) {
            case ChainItemType.PAST:
                this.setRecieved(true);
                this.disableTimer();
                this.darkness = SpriteUtils.addImage(this.scene, 0, 0, Keys.CHAIN_DARK_GREY)
                    .setSize(CU.CANVAS_WIDTH, this.getHeight(bo.decorationId))
                    .setOrigin(0, 0);
                this.add(this.darkness);
                break;
            case ChainItemType.CURRENT:
                // const light = SpriteUtils.addImage(this.scene, 0, 3, Keys.CHAIN_LIGHT_GREEN)
                //     .setOrigin(0, 0);
                // SpriteUtils.setDispSize(light, CU.CANVAS_WIDTH, this.getHeight(bo.decorationId));
                // this.add(light);
                break;
            case ChainItemType.FUTURE:
                this.darkness = SpriteUtils.addImage(this.scene, 0, 0, Keys.CHAIN_DARK_GREY)
                    .setSize(CU.CANVAS_WIDTH, this.getHeight(bo.decorationId))
                    .setOrigin(0, 0);
                this.add(this.darkness);
                break;
        }

        if (currIndex !== 0) {
            const trg = SpriteUtils.addImage(this.scene, 300, 2, Keys.ATLAS_CHAIN, 'tri');
            this.add(trg);
        }
    }

    protected initialize(bankOption: BankOption) {

    }

    public darken() {
        this.chainItemType = ChainItemType.PAST;
        if (!this.darkness) {
            this.darkness = SpriteUtils.addImage(this.scene, 0, 0, Keys.CHAIN_DARK_GREY)
                .setSize(CU.CANVAS_WIDTH, this.height).setOrigin(0, 0).setAlpha(0);
            this.add(this.darkness);
        }
        this.disableTimer();
        this.darkness.parentContainer.bringToTop(this.darkness);

        this.scene.tweens.add({
            targets: this.darkness,
            alpha: 1,
            delay: 250,
            duration: 750
        });
    }

    public lighten(callback: () => unknown) {
        this.chainItemType = ChainItemType.CURRENT;
        if (this.darkness) {
            this.scene.tweens.add({
                targets: [this.darkness, this.lock],
                alpha: 0,
                delay: 250,
                duration: 750,
                onComplete() {
                    callback();
                }
            });
        }
    }

    protected getDescPosX(bo: BankOption): number {
        if (bo.decorationId === 'chain_ny_1' || bo.decorationId === 'chain_ny_2' || bo.decorationId === 'chain_ny_3' || bo.decorationId === 'chain_1') {
            return this.getTitlePosX() + 2;
        }
        return super.getDescPosX(bo);
    }

    protected getDescPosY(bo: BankOption): number {
        if (bo.decorationId === 'chain_ny_1' || bo.decorationId === 'chain_ny_2' || bo.decorationId === 'chain_ny_3' || bo.decorationId === 'chain_1') {
            return 55;
        }
        return super.getDescPosY(bo);
    }

    protected getStrokeColor(): string {
        return '#efefef';
    }

    protected setDescStroke(desc: Text) {
        desc.setStroke('#2a2a2a', 4);
    }
}
